import {
    extractHourFromCreateTime,
    getCleaningReportDayKey,
    getCleaningReportTaskStartTime,
    localeToBcp47,
    cleaningReportYmdToChartLabel,
} from '../../CleaningReportsDashboard/cleaningReportUtils';

/**
 * Calcula a eficiência em m² por minuto.
 * @param {number} area Area in m².
 * @param {number} timeSeconds Time in seconds.
 * @returns {number} Eficiência em m²/min.
 */
export const calculateEfficiency = (area, timeSeconds) => {
    const numericArea = Number(area);
    const numericTimeSeconds = Number(timeSeconds);

    if (!numericArea || !numericTimeSeconds || numericTimeSeconds <= 0) {
        return 0;
    }

    const minutes = Math.max(1, numericTimeSeconds / 60);
    const eff = numericArea / minutes;

    return eff > 500 ? 500 : eff;
};

/**
 * Calcula a eficiência média de uma lista de relatórios de limpeza.
 * @param {Array} list Array de relatórios.
 * @returns {number}
 */
export const getAverageEfficiency = list => {
    if (!list || !list.length) return 0;

    let totalArea = 0;
    let totalTime = 0;

    list.forEach(item => {
        totalArea += Number(item.clean_area) || 0;
        totalTime += Number(item.clean_time) || 0;
    });

    return calculateEfficiency(totalArea, totalTime);
};

/**
 * Formata o valor de eficiência.
 * @param {number} value
 * @returns {string}
 */
export const formatEfficiency = value => {
    if (value == null || value === 0) return 'N/A';
    return `${Number(value).toFixed(1)} m²/min`;
};

const pad2 = num => String(num).padStart(2, '0');

export const buildEfficiencySeries = (
    list,
    localeCode = 'pt_BR',
    periodDates = null
) => {
    if (!list || !list.length) return [];

    const localeFormat = localeToBcp47(localeCode);

    let isSingleDay = false;
    if (periodDates && periodDates.startDate && periodDates.endDate) {
        if (periodDates.startDate === periodDates.endDate) {
            isSingleDay = true;
        }
    }

    if (isSingleDay) {
        const byHour = new Array(24)
            .fill(null)
            .map(() => ({ area: 0, time: 0 }));

        list.forEach(item => {
            const h = extractHourFromCreateTime(
                getCleaningReportTaskStartTime(item)
            );
            if (h == null) return;
            byHour[h].area += Number(item.clean_area) || 0;
            byHour[h].time += Number(item.clean_time) || 0;
        });

        return byHour.map((data, hour) => {
            const eff = calculateEfficiency(data.area, data.time);
            return {
                date: `${pad2(hour)}h`,
                efficiency: eff ? Number(eff.toFixed(2)) : 0,
            };
        });
    }

    const byDay = {};
    list.forEach(item => {
        const day = getCleaningReportDayKey(
            getCleaningReportTaskStartTime(item)
        );
        if (day === '—') return;
        if (!byDay[day]) {
            byDay[day] = { area: 0, time: 0 };
        }
        byDay[day].area += Number(item.clean_area) || 0;
        byDay[day].time += Number(item.clean_time) || 0;
    });

    const sortedDays = Object.keys(byDay).sort();
    return sortedDays.map(day => {
        const eff = calculateEfficiency(byDay[day].area, byDay[day].time);
        return {
            date: cleaningReportYmdToChartLabel(day, localeFormat),
            efficiency: eff ? Number(eff.toFixed(2)) : 0,
        };
    });
};
